import React from 'react'
import { useTranslation } from "react-i18next";

const TableFooter = ({ dateTime, showData }) => {
  const { t } = useTranslation();


  if (showData) return <div className='h-6'></div>
  return (
    <div className='h-6'>{t("datacard.lastUpdate")}  {dateTime}</div>
  )

}

export default TableFooter